module.exports = __webpack_public_path__ + "img/map.1f367825.png";